import React from "react";
import { Route, Redirect } from "react-router-dom";

const ProtectedRoute = ({ component: Component, ...rest }) => {
  let user = localStorage.getItem("userInfo");
  return (
    <Route
      {...rest}
      render={props => user ? <Component {...props} /> : <Redirect to="/login" />
      }
    ></Route>
  );
};

export default ProtectedRoute;
